module.exports = __webpack_public_path__ + "img/ChildView.9b7d435c.svg";